"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = {
    key: 0,
    class: "mb-3"
};
const _hoisted_2 = { class: "text-left font-bold uppercase border-b border-slate-400" };
const _hoisted_3 = { class: "text-left" };
const _hoisted_4 = {
    key: 0,
    class: "font-bold text-blue"
};
const _hoisted_5 = {
    key: 1,
    class: "text-left"
};
const _hoisted_6 = { key: 0 };
const _hoisted_7 = { class: "text-left" };
const _hoisted_8 = { class: "text-left" };
const _hoisted_9 = {
    key: 0,
    class: "text-left"
};
const _hoisted_10 = {
    key: 1,
    class: "text-left font-bold text-blue"
};
const _hoisted_11 = {
    key: 1,
    class: "mb-3"
};
const _hoisted_12 = ["id"];
const _hoisted_13 = {
    key: 0,
    class: "font-bold text-blue"
};
const _hoisted_14 = { key: 1 };
const vue_3 = require("vue");
const ResponsiveTable_vue_1 = __importDefault(require("../../components/ResponsiveTable/ResponsiveTable.vue"));
const i18n_1 = require("../../common/i18n");
const securityStore_1 = require("../../stores/security/securityStore");
const shop_1 = require("../../common/utils/shop");
const ShopConfig_1 = require("../../common/utils/ShopConfig");
const CartProduct_1 = __importDefault(require("../../stores/carts/CartProduct"));
//LOCAL VARIABLES
exports.default = (0, vue_1.defineComponent)({
    __name: 'OrderSummary',
    props: {
        myOrder: {
            type: Object,
            required: false,
        },
    },
    setup(__props) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        const props = __props;
        const securityStore = (0, securityStore_1.useSecurityStore)();
        const customerCurrencyCode = (0, vue_3.computed)(() => {
            if (securityStore.authenticatedUser !== null) {
                return securityStore.authenticatedUser.customer.currencyCode;
            }
            return "";
        });
        const isRomanian = (0, vue_3.computed)(() => ShopConfig_1.ShopConfig.getShopLocation() === "ROU");
        const orderItemOpenedListFields = (0, vue_3.ref)([
            {
                key: "productId",
                label: (_a = (0, i18n_1.trans)("item_id_opened_list", "Item ID", "order_summary")) !== null && _a !== void 0 ? _a : "Item ID",
                value: "productId",
            },
            {
                key: "productName",
                label: (_b = (0, i18n_1.trans)("name_opened_list", "Name", "order_summary")) !== null && _b !== void 0 ? _b : "Name",
                value: "productName",
            },
            {
                key: "quantity",
                label: (_c = (0, i18n_1.trans)("quantity_opened_list", "Quantity", "order_summary")) !== null && _c !== void 0 ? _c : "Quantity",
                value: "quantity",
            },
            {
                key: "reservedQuantity",
                label: (_d = (0, i18n_1.trans)("reserved_quantity_opened_list", "Reserved Quantity", "order_summary")) !== null && _d !== void 0 ? _d : "Reserved Quantity",
                value: "reservedQuantity",
            },
            {
                key: "formattedPriceUnitNet",
                label: (_e = (0, i18n_1.trans)("net_unit_price_opened_list", "Net Unit Price", "order_summary")) !== null && _e !== void 0 ? _e : "Unit Net Price",
                value: "formattedPriceUnitNet",
            },
            {
                key: "formattedNetAmount",
                label: (_f = (0, i18n_1.trans)("net_amount_opened_list", "Net Amount", "order_summary")) !== null && _f !== void 0 ? _f : "Net Amount",
                value: "formattedNetAmount",
            },
        ]);
        const orderShippingListFields = (0, vue_3.ref)([
            {
                key: "id",
                label: (_g = (0, i18n_1.trans)("order_id_opened_list", "Order ID", "order_summary")) !== null && _g !== void 0 ? _g : "Order ID",
                value: "id",
            },
            {
                key: "site",
                label: (_h = (0, i18n_1.trans)("site_opened_list", "Site", "order_summary")) !== null && _h !== void 0 ? _h : "Site",
                value: "site",
                visible: !isRomanian.value
            },
            {
                key: "shippingAddress",
                label: (_j = (0, i18n_1.trans)("shipping_address_opened_list", "Shipping Address", "order_summary")) !== null && _j !== void 0 ? _j : "Shipping Address",
                value: "shippingAddress",
            },
            {
                key: "shippingMode",
                label: (_k = (0, i18n_1.trans)("shipping_mode_opened_list", "Shipping Mode", "order_summary")) !== null && _k !== void 0 ? _k : "Shipping Mode",
                value: "shippingMode",
            },
            {
                key: "axaptaId",
                label: (_l = (0, i18n_1.trans)("axapta_id", "Axapta ID", "order_summary")) !== null && _l !== void 0 ? _l : "Axapta ID",
                value: "axaptaId",
            }
        ]);
        const getShippingAddress = (order) => {
            if (order.shippingCustomerAddressId && order.shippingCustomerAddress) {
                return order.shippingCustomerAddress['zip'] + ", " +
                    order.shippingCustomerAddress['city'] + ", " +
                    order.shippingCustomerAddress['street'] + " (" +
                    order.shippingCustomerAddress['name'] + ")";
            }
            else if (order.shippingPickupPointId && order.shippingPickupPointSite) {
                return order.shippingPickupPointSite['zip'] + ", " +
                    order.shippingPickupPointSite['city'] + ", " +
                    order.shippingPickupPointSite['street'] + " (" +
                    order.shippingPickupPointSite['siteName'] + ")";
            }
            else if (order.shippingPersonalPickupPointId && order.shippingPersonalPickupPointSite) {
                return order.shippingPersonalPickupPointSite['zip'] + ", " +
                    order.shippingPersonalPickupPointSite['city'] + ", " +
                    order.shippingPersonalPickupPointSite['street'] + " (" +
                    order.shippingPersonalPickupPointSite['siteName'] + ")";
            }
            else {
                return order.shippingCustomAddressZipCode + ", " +
                    order.shippingCustomAddressCity + ", " +
                    order.shippingCustomAddressStreet + " (" +
                    order.shippingCustomAddressName + ")";
            }
        };
        const getReservedQuantity = (order, id) => {
            let reservedQuantity = 0;
            // Ax normál productId-t ad vissza, így a weben kezelt @-os kódot is tisztázni kell, hogy össze tudjuk hasonlítani.
            id = CartProduct_1.default.cleanProductId(id);
            order.axOrderRows.forEach(row => {
                if (row.productId == id) {
                    reservedQuantity += parseInt(row.reservedQuantity); // telephelyi foglalt
                    reservedQuantity += parseInt(row.remoteQuantity); // gyártói
                    if (row.referencedSite) {
                        reservedQuantity += parseInt(row.referencedReservedQuantity);
                    }
                }
            });
            return reservedQuantity;
        };
        return (_ctx, _cache) => {
            var _a, _b, _c, _d, _e;
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                (__props.myOrder)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                        (0, vue_2.createElementVNode)("h1", _hoisted_2, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("order_summary", "Order summary", "order_summary")), 1),
                        (0, vue_2.createVNode)(ResponsiveTable_vue_1.default, {
                            fields: orderShippingListFields.value,
                            "onUpdate:fields": _cache[0] || (_cache[0] = ($event) => ((orderShippingListFields).value = $event)),
                            items: [__props.myOrder],
                            striped: "",
                            condensed: "",
                            panel: ""
                        }, {
                            "cell-id": (0, vue_2.withCtx)(({ item: order }) => [
                                (0, vue_2.createElementVNode)("div", _hoisted_3, (0, vue_2.toDisplayString)(order.id), 1)
                            ]),
                            "cell-site": (0, vue_2.withCtx)(({ item: order }) => [
                                (!__props.myOrder.axOrderHead)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_4, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("soon", "SOON", "order_summary")), 1))
                                    : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_5, [
                                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(order.axOrderHead, (axOrder) => {
                                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, {
                                                key: axOrder.axaptaId
                                            }, [
                                                (0 == axOrder.interCompanyOrder)
                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_6, (0, vue_2.toDisplayString)(axOrder.siteId) + " - " + (0, vue_2.toDisplayString)(axOrder.siteName), 1))
                                                    : (0, vue_2.createCommentVNode)("", true)
                                            ], 64));
                                        }), 128))
                                    ]))
                            ]),
                            "cell-shippingAddress": (0, vue_2.withCtx)(({ item: order }) => [
                                (0, vue_2.createElementVNode)("div", _hoisted_7, (0, vue_2.toDisplayString)(getShippingAddress(__props.myOrder)), 1)
                            ]),
                            "cell-shippingMode": (0, vue_2.withCtx)(({ item: order }) => [
                                (0, vue_2.createElementVNode)("div", _hoisted_8, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("shipping_mode_" + order.shippingModeId, order.shippingModeId, "order_summary")), 1)
                            ]),
                            "cell-axaptaId": (0, vue_2.withCtx)(({ item: order }) => [
                                (order.axaptaIdList)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_9, (0, vue_2.toDisplayString)(order.axaptaIdList), 1))
                                    : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_10, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("soon", "SOON", "order_summary")), 1))
                            ]),
                            _: 1
                        }, 8, ["fields", "items"])
                    ]))
                    : (0, vue_2.createCommentVNode)("", true),
                (((_a = __props.myOrder) === null || _a === void 0 ? void 0 : _a.products) !== null && ((_c = (_b = __props.myOrder) === null || _b === void 0 ? void 0 : _b.products) === null || _c === void 0 ? void 0 : _c.length) > 0)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_11, [
                        (0, vue_2.createVNode)(ResponsiveTable_vue_1.default, {
                            fields: orderItemOpenedListFields.value,
                            "onUpdate:fields": _cache[1] || (_cache[1] = ($event) => ((orderItemOpenedListFields).value = $event)),
                            items: (_e = (_d = __props.myOrder) === null || _d === void 0 ? void 0 : _d.products) !== null && _e !== void 0 ? _e : [],
                            striped: "",
                            condensed: "",
                            panel: ""
                        }, {
                            "cell-productId": (0, vue_2.withCtx)(({ item: orderItemOpened }) => [
                                (0, vue_2.createElementVNode)("div", {
                                    id: `order-summary-product-${orderItemOpened.id}`
                                }, (0, vue_2.toDisplayString)((0, vue_2.unref)(CartProduct_1.default).cleanProductId(orderItemOpened.id)), 9, _hoisted_12)
                            ]),
                            "cell-productName": (0, vue_2.withCtx)(({ item: orderItemOpened }) => [
                                (0, vue_2.createElementVNode)("div", null, (0, vue_2.toDisplayString)(orderItemOpened.name), 1)
                            ]),
                            "cell-quantity": (0, vue_2.withCtx)(({ item: orderItemOpened }) => [
                                (0, vue_2.createElementVNode)("div", null, (0, vue_2.toDisplayString)(orderItemOpened.quantity), 1)
                            ]),
                            "cell-reservedQuantity": (0, vue_2.withCtx)(({ item: orderItemOpened }) => [
                                (!__props.myOrder.axOrderRows)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_13, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("soon", "SOON", "order_summary")), 1))
                                    : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_14, (0, vue_2.toDisplayString)(getReservedQuantity(__props.myOrder, orderItemOpened.id)), 1))
                            ]),
                            "cell-formattedPriceUnitNet": (0, vue_2.withCtx)(({ item: orderItemOpened }) => [
                                (0, vue_2.createElementVNode)("div", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(shop_1.formatPrice)(orderItemOpened.priceNet, (0, vue_2.unref)(customerCurrencyCode))), 1)
                            ]),
                            "cell-formattedNetAmount": (0, vue_2.withCtx)(({ item: orderItemOpened }) => [
                                (0, vue_2.createElementVNode)("div", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(shop_1.formatPrice)(orderItemOpened.priceNet *
                                    orderItemOpened.quantity, (0, vue_2.unref)(customerCurrencyCode))), 1)
                            ]),
                            _: 1
                        }, 8, ["fields", "items"])
                    ]))
                    : (0, vue_2.createCommentVNode)("", true)
            ], 64));
        };
    }
});
